import { type ReactElement, type PropsWithChildren } from 'react'
import { APIProvider } from '@vis.gl/react-google-maps'
import { GOOGLE_MAPS_API_KEY } from './apiKey'

export const GoogleMapProvider = ({ children }: PropsWithChildren): ReactElement => {
  return <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>{children}</APIProvider>
}
